import React from 'react';
import Pro01 from "../../images/services/dt/Digital-superiority.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Superiority">
                            <h2>Experience-Driven Digital Superiority</h2>
                        </div>
                        <p>Digital superiority driven by unrivaled experience is what we aim for. TekRevol’s belief in
                            digital excellence keeps getting firm with each passing day, which is what we deliver to our
                            clients. Each of the digital transformation projects we initiate is a challenge to craft
                            experiences not found elsewhere and enable businesses to succeed.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className=" agile_title my-auto offset-xl-1">
                        <div className=" content_pointer">
                            <div className=" pointers_item">
                                <div className=" title_count">37+<span>Projects Completed</span></div>
                            </div>
                            <div className=" pointers_item">
                                <div className=" title_count">21+<span>Businesses Served</span></div>
                            </div>
                            <div className=" pointers_item">
                                <div className=" title_count">08+<span>Industries Covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect=" blur" alt=" Image" className=" img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;